import { satisfiesRecord } from "@nens/shared-utils";

const MAP_LINE: [number, number, number] = [79, 162, 202];

export const COLORS = satisfiesRecord<
  [number, number, number] | [number, number, number, number]
>()({
  INVISIBLE: [0, 0, 0, 0],
  RED: [255, 0, 0],
  MAP_LINE,
  MAP_LINE_50: [...MAP_LINE, 255 / 2],
});
